if (!document.querySelector('script[src="//cdn.cian.site/finance/cian-loader/widget.js"]')) {
    const s = document.createElement('script');
    s.src = '//cdn.cian.site/finance/cian-loader/widget.js';
    document.head.appendChild(s);
}

if (!customElements.get('preview-container')) customElements.define('preview-container', class extends HTMLElement {
    connectedCallback() {
        this.style.overflowY = "scroll";
        this.style.position = "relative";
        this.style.setProperty('-ms-overflow-style', "none");
        this.style.setProperty('scrollbar-width', "none");
        if (!document.head.querySelector('style[preview-container]')) {
            const s = document.createElement('style');
            s.setAttribute('preview-container', "");
            s.innerHTML = `
                listing-photo-gallery preview-container::-webkit-scrollbar {display: none;}
                listing-photo-gallery preview-container :last-child {height: 82px !important}
                listing-photo-gallery [array]:hover  {opacity: 50% !important}
            `;
            document.head.appendChild(s);
        }
        let wasMove = false;
        let start = false;
        let scrollStart;
        this.addEventListener('mousedown', ev => {
            start = ev.pageY;
            scrollStart = this.scrollTop;
            wasMove = false;
        });
        window.addEventListener('mousemove', ev => {
            if (ev.buttons && this.children.length > 4 && Math.abs(ev.pageY - start) > 5) {
                this.scrollTop = scrollStart - (ev.pageY - start);
                wasMove = true;
            }
        });
        window.addEventListener('mouseup', ev => start = false);
        this.addEventListener('click', (e) => {
            if (e.target.closest('preview-image') && !wasMove) {
                this.dispatchEvent(new CustomEvent('select-photo', {
                    bubbles: true,
                    detail: {
                        mini: e.target.closest('preview-image').getAttribute('mini'),
                        full: e.target.closest('preview-image').getAttribute('full'),
                        index: Number.parseInt(e.target.closest('preview-image').getAttribute('index')),
                    }
                }));
                e.stopPropagation();
            }
        });
        let scrollHandler = () => {
            this.dispatchEvent(new CustomEvent("scroll-percent", {bubbles: true, detail: this.scrollTop / (this.scrollHeight - this.getBoundingClientRect().height)}));
            this.dispatchEvent(new CustomEvent(this.scrollTop > 0 ? "show-top": "hide-top", {bubbles: true}));
            this.dispatchEvent(new CustomEvent(this.scrollHeight-this.scrollTop > this.getBoundingClientRect().height  + 8 ? "show-bottom": "hide-bottom", {bubbles: true}));
        };
        this.addEventListener('scroll', scrollHandler);
    }
});
if (!customElements.get('preview-image')) customElements.define('preview-image', class extends HTMLElement {
    static get observedAttributes() {
        return ['img-selected'];
    }

    attributeChangedCallback() {
        if (this.hasAttribute('img-selected')) {
            const parent = this.closest('preview-container');
            if (parent) {
                parent.querySelectorAll('[img-selected]').forEach(e => {
                    if (e !== this) {
                        e.removeAttribute('img-selected');
                    }
                });
            }
            if(this.querySelector('[selection]')) this.querySelector('[selection]').style.opacity = '50%';
        } else {
            this.querySelector('[selection]').style.opacity = '0';
        }
    }


    connectedCallback() {
        this.style.display = "block";
        this.style.height = "90px";
        this.style.position = "relative";
        this.innerHTML =
            `<img loading="lazy" draggable="0" style="cursor: pointer; width: 136px; min-width: 136px; max-width: 136px; height: 82px; user-select: none; border-radius: var(--img-radius, 4px); object-fit: cover; object-position: center;" src="${this.getAttribute("mini")}">
            <div selection style="position: absolute; top: 0; left 0; width: 100%; height: 100%; border-radius: var(--img-radius, 4px); background: var(--dark-color); pointer-events: none; opacity: ${this.hasAttribute('img-selected') ? "50%" : "0"}"></div>`
    }
});
if (!customElements.get('listing-photo-gallery')) {
    customElements.define('listing-photo-gallery', class extends HTMLElement {
        static get observedAttributes() {
            return ['selected-index', 'offer-id', 'jk-ref'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (
              (name === 'offer-id' || name ==='jk-ref')
              && oldValue !== newValue
            ) {
                this.connectedCallback()
            }
            const idx = Number.parseInt(this.getAttribute('selected-index'));
            if (!isNaN(idx)) {
                let preview = this.querySelector(`preview-image:nth-child(${idx + 1})`);
                preview.setAttribute('img-selected', "");
                this.querySelector('img[big]').src = preview.getAttribute('full');
                this.querySelector('[index-display]').innerHTML = idx + 1;
                this.querySelector('[prev] path').style.fill = idx === 0 ? '#AAA' : 'white';
                this.querySelector('[next] path').style.fill = idx === this.photoCount - 1 ? '#AAA' : 'white';
                const selectedY = idx * 90;
                let element = this.querySelector('preview-container');
                if (selectedY + 82 - element.scrollTop > this.getBoundingClientRect().height) {
                    element.scrollTop = Math.round(selectedY + 82 - this.getBoundingClientRect().height + 4);
                }
                if (selectedY - element.scrollTop < 0) {
                    element.scrollTop = selectedY;
                }

            }
        }

        connectedCallback() {
            // this.style.display = 'block';
            this.style.position = 'relative';
            this.style.width = '100%';
            this.style.height = `352px`;
            this.style.setProperty(`--cian-slide`, "-15%");
            this.innerHTML = '<cian-loader style="display: block; position: absolute;left: calc(50% - 22px);top: calc(50% - 3px);"></cian-loader>';
            this.addEventListener('select-photo', e => {
                this.setAttribute('selected-index', e.detail.index);
            });
            let cacheUrl = false;
            let renderUrl = false;
            if (this.hasAttribute('jk-ref')) {
                const jkRef = this.getAttribute('jk-ref');
                const id = /-([0-9]+)[^0-9]*$/.exec(jkRef)[1];
                cacheUrl = `https://cdn.cian.site/finance/content-distribution/jk/${id}.json`;
                renderUrl = `https://content-distribution-photogallery-service.content.cian.ru/api/v1/jk/&?jk_name=${encodeURIComponent(jkRef)}`;
            }
            if (this.hasAttribute('offer-id')) {
                const id = this.getAttribute('offer-id');
                const editDate = this.getAttribute('edit-date');
                if(editDate) {
                    const date = new Date(editDate);
                    const fileWithFolder = `${date.getUTCFullYear()}/${date.getUTCMonth()}/${date.getUTCDate()}/${id}-${date.getUTCHours()}-${date.getUTCMinutes()}-${date.getUTCSeconds()}.json`;
                    cacheUrl = `https://cdn.cian.site/finance/content-distribution/flat-photo-new/${fileWithFolder}`;
                }
                else {
                    cacheUrl = `https://cdn.cian.site/finance/content-distribution/flat-photo/${id}.json`;
                }
                renderUrl = `https://content-distribution-photogallery-service.content.cian.ru/api/v1/flat/${id}`;
            }
            fetch(cacheUrl).then((result) => {
                if (result.ok) {
                    return result.json();
                }
                return fetch(renderUrl).then((result) => {
                    if (result.ok) {
                        return result.json();
                    }
                    return [];
                })
            }).catch(() => fetch(renderUrl).then((result) => {
                    if (result.ok) {
                        return result.json();
                    }
                    return [];
                })
            ).then((data) => {
                if (data.length) {
                    this.renderPhotos(data);
                } else {
                    this.renderNoPhoto();
                }
            });
        }

        renderNoPhoto() {
            this.style.background = '#BBB';
            this.innerHTML = '<div style="display: block; position: absolute;left: calc(50% - 22px);top: calc(50% - 3px);">Нет фото</div>'
        }

        renderPhotos(photos) {
            this.photoCount = photos.length;
            const previews = photos.map((v, i) => {
                return `<preview-image ${i === 0 ? "img-selected" : ""} index="${i}" mini="${v.thumbnailUrl}" full="${v.fullUrl}"></preview-image>`;
            }).join("\n");
            const visible = this.getBoundingClientRect().y >= 0 && this.getBoundingClientRect().y <= (window.innerHeight || document.documentElement.clientHeight);
            this.innerHTML = `
            <div style='display: flex; height: 100%; width: 100%'>
                <div big-display style="overflow: hidden; position: relative; margin-right: 8px; flex-grow: 1">
                    <div prev style="position: absolute; cursor: pointer; width: 15%; height: 100%; left: var(--cian-slide); top: 0;">
                        <div array style="position: absolute; background: var(--dark-color); width: 40px; height: 40px; left: calc(50% - 20px); top: calc(50% - 20px); border-radius: 50%; opacity: 20%"></div>
                        <svg style="position: absolute; left: calc(50% - 12px); top: calc(50% - 12px); pointer-events: none" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.5 11H7.97L11.617 7.46799C12.015 7.08399 12.024 6.45099 11.641 6.05399C11.255 5.65699 10.623 5.64799 10.227 6.03199L4.805 11.282C4.609 11.47 4.5 11.729 4.5 12C4.5 12.271 4.609 12.53 4.805 12.718L10.227 17.968C10.421 18.156 10.671 18.25 10.922 18.25C11.183 18.25 11.444 18.148 11.641 17.946C12.024 17.549 12.015 16.916 11.617 16.532L7.97 13H18.5C19.053 13 19.5 12.552 19.5 12C19.5 11.448 19.053 11 18.5 11Z" fill="white"/>
                        </svg>
                    </div>
                    <div next style="position: absolute; cursor: pointer; width: 15%; height: 100%; right: var(--cian-slide); top: 0;">
                        <div array style="position: absolute; background: var(--dark-color); width: 40px; height: 40px; left: calc(50% - 20px); top: calc(50% - 20px); border-radius: 50%; opacity: 20%"></div>
                        <svg style="position: absolute; left: calc(50% - 12px); top: calc(50% - 12px); pointer-events: none" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.5 11H16.03L12.383 7.46799C11.985 7.08399 11.976 6.45099 12.359 6.05399C12.745 5.65699 13.377 5.64799 13.773 6.03199L19.195 11.282C19.391 11.47 19.5 11.729 19.5 12C19.5 12.271 19.391 12.53 19.195 12.718L13.773 17.968C13.579 18.156 13.329 18.25 13.078 18.25C12.817 18.25 12.556 18.148 12.359 17.946C11.976 17.549 11.985 16.916 12.383 16.532L16.03 13H5.5C4.947 13 4.5 12.552 4.5 12C4.5 11.448 4.947 11 5.5 11Z" fill="white"/>
                        </svg>
                    </div>
                    <img big ${!visible ? "loading='lazy'": ""} draggable="0" style="object-fit: cover; user-select: none; object-position: center; height: 352px; border-radius: var(--img-radius, 4px); width: 100%" src="${photos[0].fullUrl}">
                    <div style="font-size: 14px; width: 60px; left: calc(50% - 30px); padding: 4px 0; color: white; position: absolute; bottom: 12px; background-color: #0005; border-radius: 22px; display: flex; justify-content: center"><div index-display>1</div><div>/${photos.length}</div></div>
                </div>
                <div style="position: relative">
                    <div top-shadow style="z-index: 1; position: absolute; display: none; top: 0; left: 0; width: 100%; height: 20px; background: linear-gradient(0deg, #FFF0, #FFFF);  pointer-events: none;"></div>
                    <preview-container style="height: 352px; display: block">
                        ${previews}
                    </preview-container>
                    <div bottom-shadow style="position: absolute; display: none; bottom: 0; left: 0; width: 100%; height: 20px; background: linear-gradient(0deg, #FFFF, #FFF0);  pointer-events: none;"></div>
                    <div scroll-indicator style="position: absolute; display: none; top: 0; right: -6px; width: 4px; height: 20px; background: var(--dark-color); opacity: 50%; pointer-events: none;"></div>
                </div>
                </div>
            </div>
        `;
            let topShadow = this.querySelector('[top-shadow]');
            let bottomShadow = this.querySelector('[bottom-shadow]');
            topShadow.style.display = 'none';
            bottomShadow.style.display = this.querySelector('preview-container').children.length > 4 ? 'block' : 'none';
            let hideIndicator = false;
            this.addEventListener("scroll-percent", (e) => {
                let indicator = this.querySelector('[scroll-indicator]');
                indicator.style.display = 'block';
                const top = (352 - 20) * e.detail;
                indicator.style.top = top + "px";
                hideIndicator = new Date(new Date().getTime() + 3000);
                setTimeout(() => {
                    if (new Date().getTime() > hideIndicator.getTime()) {
                        indicator.style.display = 'none';
                    }
                }, 3005);
            });
            this.addEventListener("show-top", () => topShadow.style.display = 'block');
            this.addEventListener("hide-top", () => topShadow.style.display = 'none');
            this.addEventListener("show-bottom", () => bottomShadow.style.display = 'block');
            this.addEventListener("hide-bottom", () => bottomShadow.style.display = 'none');
            this.setAttribute('selected-index', "0");
            this.addEventListener('mouseenter', () => {
                if(!localStorage.getItem('cian-gallery-demo-animation')){
                    localStorage.setItem('cian-gallery-demo-animation', "true");
                    const offsets = [1, 3, 6, 10, 20, 30, 40, 50, 60, 70, 80, 70, 60, 50, 40, 30, 20, 10, 6, 3, 1, 0];
                    const animate = () => {
                        const [offset] = offsets.splice(0, 1);
                        this.querySelector("preview-container").scrollTop = offset;
                        if(offsets.length) {
                            setTimeout(animate, 40);
                        }
                    };
                    animate();
                }
            });
            this.querySelector('[big-display]').addEventListener('mouseenter', () => {
                this.style.setProperty(`--cian-slide`, "0");
            });
            this.querySelector('[big-display]').addEventListener('mouseleave', () => {
                this.style.setProperty(`--cian-slide`, "-15%");
            });
            this.querySelector('[next]').addEventListener('click', ev=> {
                let idx = Number.parseInt(this.getAttribute('selected-index'));
                this.setAttribute('selected-index', isNaN(idx) ? 0 : Math.min(idx + 1, this.photoCount - 1));
                ev.stopPropagation();
            })
            this.querySelector('[prev]').addEventListener('click', ev=> {
                let idx = Number.parseInt(this.getAttribute('selected-index'));
                this.setAttribute('selected-index', isNaN(idx) ? 0 : Math.max(idx - 1, 0));
                ev.stopPropagation();
            })
        }
    });
}
